import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private readonly SIDEBAR_STATE_KEY = 'sidebarExpanded';
  private isExpandedSubject: BehaviorSubject<boolean>;
  public isExpanded$: Observable<boolean>;

  constructor() { 
    // Initialize with saved state from localStorage, default to true if not found
    const savedState = this.getSavedState();
    this.isExpandedSubject = new BehaviorSubject<boolean>(savedState);
    this.isExpanded$ = this.isExpandedSubject.asObservable();
  }

  toggleSidebar() {
    const newState = !this.isExpandedSubject.value;
    this.setExpanded(newState);
  }

  setExpanded(expanded: boolean) {
    this.isExpandedSubject.next(expanded);
    this.saveState(expanded);
  }

  getIsExpanded(): boolean {
    return this.isExpandedSubject.value;
  }

  private getSavedState(): boolean {
    try {
      const saved = localStorage.getItem(this.SIDEBAR_STATE_KEY);
      return saved !== null ? JSON.parse(saved) : true; // Default to expanded (true)
    } catch (error) {
      console.warn('Error reading sidebar state from localStorage:', error);
      return true; // Default to expanded if error
    }
  }

  private saveState(expanded: boolean): void {
    try {
      localStorage.setItem(this.SIDEBAR_STATE_KEY, JSON.stringify(expanded));
    } catch (error) {
      console.warn('Error saving sidebar state to localStorage:', error);
    }
  }
}
